import http from '@/http/aisea/axios'
const resource = "/enterprises/crews";

export default {

  // 承認・登録
  add(enterpriseCrewId, timesheetId, payload) {
    return http.post(`${resource}/${enterpriseCrewId}/timesheet/${timesheetId}/approvals`, payload);
  },

  // 申請差し戻し
  update(enterpriseCrewId, timesheetId, payload) {
    return http.put(`${resource}/${enterpriseCrewId}/timesheet/${timesheetId}/approvals`, payload);
  },

  // 承認差し戻し
  delete(enterpriseCrewId, timesheetId, payload) {
    return http.delete(`${resource}/${enterpriseCrewId}/timesheet/${timesheetId}/approvals`, {data: payload});
  },

  search(payload) {
    return http.get(`${resource}/timesheet`, {
      params: payload
    });
  },

};
